// ═══════════════════════════════════════════════════════════════
// PROMPT BUILDERS
// ═══════════════════════════════════════════════════════════════
export const buildExplainPrompt = (note, role) =>
  `I'm preparing for a ${role} ML interview. Explain this concept clearly:

CONCEPT: ${note.title}
SUMMARY: ${note.summary}

Give me:
1. 🎯 Core idea in 2 sentences
2. 💡 Best real-world analogy
3. 🔑 3 key interview points to remember
4. ${role === "AI Architect" ? "🏗️ Architecture/business tradeoff insight" : role === "Data Scientist" ? "🔬 Mathematical intuition" : "💻 Key implementation detail"}
5. ❓ One tricky interview question + expert answer

Be concise and memorable. Focus on what interviewers actually ask.`;

export const buildQuizExplainPrompt = (q, correctIdx, userIdx, topic, role) =>
  `I'm studying ${topic} for a ${role} interview.

Quiz question I just answered:
QUESTION: ${q.q}
OPTIONS: ${q.opts.map((o, i) => `${["A","B","C","D"][i]}) ${o}`).join(" | ")}
CORRECT: Option ${["A","B","C","D"][correctIdx]}
MY ANSWER: ${userIdx === -1 ? "Timed out" : `Option ${["A","B","C","D"][userIdx]}`} ${userIdx === correctIdx ? "✅" : "❌"}

Please explain:
1. Why ${["A","B","C","D"][correctIdx]} is correct
2. Why the wrong options are wrong
3. 💡 A real-world analogy that makes this concept stick
4. 🧠 Memory trick to never forget this
5. How this topic appears in real interviews`;

export const buildInterviewSystem = (role, company, topic) =>
  `You are a senior technical interviewer at ${company} interviewing for a ${role} position.
Focus on ${topic}.

Rules:
- Ask ONE clear interview question
- After candidate answers, respond with this EXACT format:

SCORE: X/10
STRENGTHS: [1-2 sentences on what was good]
GAPS: [1-2 sentences on what was missing]
EXPERT_ANSWER: [How a top candidate would answer in 3-4 sentences]
NEXT_QUESTION: [Your follow-up or new question]

Keep questions practical and production-focused.`;
